import $ from 'jquery';
import 'alertifyjs/build/css/alertify.css';
import alertify from 'alertifyjs';

import '@babel/polyfill';

// import 'selectize';

// import './customSelect';

import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/alert';
import 'alertifyjs/build/css/alertify.min.css'
import 'selectize/dist/css/selectize.css';

//fontion générale
(function () {
    "use strict";

    // definition des parametres de base du plugin
    var options = {
        mail_input_name: 'email',
        retour_message: ".retour_message",
        action: null
    };

    /**
     * @param change_options
     */
    $.fn.VnAjaxForm = function (change_options) {
        alertify.set('notifier', 'position', 'top-center');
        alertify.set('notifier', 'delay', 1000);

        //copy options variable to not overide it
        var option = $.extend(true, {}, options);
        // surcharge main options
        if (change_options) {
            option = $.extend(option, change_options);
        }
        //get form
        var form = $(this);
        //select div to insert into callback message
        var message_container = form.parent().find(option.retour_message);

        option = loadParameters(form, option);

        if (undefined === option.action) {
            alertify.message('No action defined, please contact an administrator');
            return null;
        }

        var timeOut = null; // evite le retour directe du formulaire
        form.submit(function (event) {
            timeOut = setTimeout(function () {
                clearInterval(timeOut);
                message_container.empty(); //on vide le message
                if (form[0].checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    alertify.error(ajaxObjectSarro.required_fields).dismissOthers();
                } else {
                    // fileData = jQuery('#FILE_ATTR_ID').prop('files')[0],
                    var formData = new FormData(form[0]);
                    formData.append('action', option.action);
                    var message_send = null
                    $.ajax({
                        type: 'POST',
                        url: ajaxObjectSarro.ajaxUrl,
                        data: formData,
                        contentType: false,
                        processData: false,
                        dataType: "json",
                        // async:false,
                        beforeSend: function () {
                            var send_point = '...';
                            var index = 0;

                            message_send = alertify.message('<div class="alert alert-info">' + ajaxObjectSarro.send_form_message + ' ' + send_point.substring(0, index % 4) + '</div>', 0, function () {
                                clearInterval(interval);
                            }).dismissOthers();

                            var interval = setInterval(function () {
                                index++;
                                message_send.setContent('<div class="alert alert-info">' + ajaxObjectSarro.send_form_message + ' ' + send_point.substring(0, index % 4) + '</div>');
                            }, 1000);
                        },
                        success: function (jSon_message) {
                            alertify.notify(jSon_message.data.message).dismissOthers();
                            if (jSon_message.success === true) {
                                clearForm(form);
                            }
                        },
                        error: function (data) {
                            alertify.error(ajaxObjectSarro.error).dismissOthers();
                        },
                        complete: function () {
                            message_send.dismiss();
                            try {
                                grecaptcha.reset(); // grecaptcha variable of google reCAPTCHA
                            } catch (error) {
                            }
                        }
                    });
                }
                form.addClass('was-validated');
            }, 200);


            event.preventDefault();
            event.stopPropagation();
        });
    };

    //set default params
    function loadParameters(element, option) {
        if (option.action === null) {
            option.action = $(element).attr('action');
        }
        return option;
    }

})();

function clearForm(form) {
    $(':input', form)
        .not(':button, :submit, :reset, :hidden')
        .val('')
        .prop('checked', false)
        .prop('selected', false);

    form.removeClass('was-validated');
}

function existAndSet(value) {
    return $.inArray(value, [null, undefined, ""]) === -1
}